"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toInternalZap = exports.toOpaqueZap = void 0;
function toOpaqueZap(input) {
    return input;
}
exports.toOpaqueZap = toOpaqueZap;
function toInternalZap(zap) {
    return zap;
}
exports.toInternalZap = toInternalZap;
